import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "@tanstack/react-router";
import { Header } from "../components/Header";
import { TagPill } from "../components/TagPill";
import { listProjects } from "../lib/posts";

export function ProjectDetailPage() {
  const { slug } = useParams({ from: "/projects/$slug" });
  const projectsQuery = useQuery({ queryKey: ["projects"], queryFn: listProjects });
  const project = projectsQuery.data?.find((item) => item.slug === slug);
  const content = project?.content;

  return (
    <>
      <Header />
      <main className="project-detail-shell">
        <Link className="back-link" to="/projects">
          ← Back to projects
        </Link>

        {projectsQuery.isLoading ? <p className="muted">Loading project…</p> : null}

        {!project && !projectsQuery.isLoading ? (
          <section className="empty-state">
            <h1>Project not found</h1>
            <p>This project may have been removed or is not available yet.</p>
          </section>
        ) : null}

        {project ? (
          <article className="project-detail">
            <section className="project-detail-hero">
              <div>
                <div className="post-tags">
                  {(project.tags ?? []).map((tag) => (
                    <TagPill key={tag.slug} tag={tag} />
                  ))}
                </div>
                <span>{content?.eyebrow ?? "/project"}</span>
                <h1>{project.title}</h1>
                <p>{project.summary}</p>
                <div className="resource-links compact">
                  {project.source_post_url?.startsWith("/post/") ? (
                    <Link className="resource-related" to={project.source_post_url}>
                      Read the article →
                    </Link>
                  ) : null}
                  {project.demo_url ? (
                    <a href={project.demo_url} rel="noreferrer" target="_blank">
                      Live demo
                    </a>
                  ) : null}
                  {project.github_url ?? content?.source_url ? (
                    <a href={project.github_url ?? content?.source_url ?? "#"} rel="noreferrer" target="_blank">
                      Source code
                    </a>
                  ) : null}
                </div>
              </div>
              {project.cover_image_url ? <img src={project.cover_image_url} alt="" /> : null}
            </section>

            <section className="project-detail-section">
              <h2>Description</h2>
              {(content?.body ?? [project.summary]).map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </section>

            <section className="project-detail-section two-columns">
              <div>
                <h2>Main Features</h2>
                <div className="detail-card-list">
                  {(content?.features ?? []).map((item) => (
                    <article key={item.title}>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </article>
                  ))}
                </div>
              </div>
              <div>
                <h2>Development Concepts</h2>
                <div className="detail-card-list">
                  {(content?.concepts ?? []).map((item) => (
                    <article key={item.title}>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </article>
                  ))}
                </div>
              </div>
            </section>
          </article>
        ) : null}
      </main>
    </>
  );
}
